export const purchasing = {
    total: "মোট",
    lineTotal: "লাইনের মোট",
    product: "পণ্য",
    quantity: "পরিমাণ",
    unitCost: "একক দাম",
    note: "নোট",
    supplier: "সরবরাহকারী",
    location: "লোকেশন",
    date: "তারিখ",
    all: "সব",
    noLines: "অন্তত একটি পণ্য যোগ করুন।",
    suppliers: {
        title: "সরবরাহকারী",
        description: "কার কাছ থেকে কেনেন, আর কাকে কত দেনা।",
        new: "নতুন সরবরাহকারী",
        search: "নাম বা ফোন দিয়ে খুঁজুন",
        columns: { name: "নাম", contact: "যোগাযোগ", phone: "ফোন", balance: "দেনা", status: "অবস্থা" },
        statuses: { active: "সক্রিয়", archived: "আর্কাইভ করা" },
        empty: "এখনও কোনো সরবরাহকারী নেই।",
        back: "সব সরবরাহকারী",
        balance: "দেনা",
        advance: "অগ্রিম দেওয়া",
        opening: "প্রারম্ভিক বকেয়া",
        form: {
            titleNew: "নতুন সরবরাহকারী",
            titleEdit: "সরবরাহকারী সম্পাদনা",
            name: "নাম",
            contactName: "যোগাযোগের ব্যক্তি",
            phone: "মোবাইল নম্বর",
            email: "ইমেইল",
            address: "ঠিকানা",
            note: "নোট",
            openingBalance: "আগের বকেয়া (প্রারম্ভিক দেনা)",
            openingBalanceHint: "সিস্টেম ব্যবহারের আগে এই সরবরাহকারীর কাছে যা দেনা ছিল। একবারই দেওয়া যায়।",
            save: "সরবরাহকারী সংরক্ষণ",
        },
        created: "সরবরাহকারী যোগ হয়েছে।",
        saved: "সরবরাহকারী সংরক্ষিত হয়েছে।",
        edit: "সম্পাদনা",
        archive: "আর্কাইভ",
        unarchive: "আর্কাইভ থেকে ফেরান",
        archived: "সরবরাহকারী আর্কাইভ হয়েছে।",
        unarchived: "সরবরাহকারী আবার সক্রিয়।",
        conflict: "অন্য কেউ এই সরবরাহকারী বদলেছেন। সর্বশেষ সংস্করণ দেখানো হচ্ছে; আবার চেষ্টা করুন।",
        receipts: "গ্রহণ করা মাল",
        returns: "ফেরত",
        payments: "পেমেন্ট",
    },
    payments: {
        title: "পেমেন্ট লিখুন",
        record: "পেমেন্ট লিখুন",
        amount: "পরিমাণ",
        method: "মাধ্যম",
        reference: "রেফারেন্স (TrxID, চেক নং)",
        paidAt: "পরিশোধের তারিখ",
        save: "পেমেন্ট সংরক্ষণ",
        recorded: "পেমেন্ট লেখা হয়েছে।",
        reverse: "বাতিল করুন",
        reverseTitle: "এই পেমেন্ট বাতিল করবেন?",
        reverseBody: "একটি বিপরীত এন্ট্রি যোগ হবে; পেমেন্টটি ইতিহাসে থাকবে।",
        reverseNote: "কেন?",
        reversed: "পেমেন্ট বাতিল হয়েছে।",
        reversal: "বাতিল এন্ট্রি",
        reversedLabel: "বাতিল",
        empty: "এখনও কোনো পেমেন্ট নেই।",
        columns: { number: "নম্বর", date: "তারিখ", amount: "পরিমাণ", method: "মাধ্যম", reference: "রেফারেন্স" },
        methods: {
            cash: "নগদ",
            bank_transfer: "ব্যাংক ট্রান্সফার",
            cheque: "চেক",
            bkash: "বিকাশ",
            nagad: "নগদ (মোবাইল)",
            rocket: "রকেট",
            other: "অন্যান্য",
        },
    },
    orders: {
        title: "পারচেজ অর্ডার",
        description: "সরবরাহকারীর কাছে কী অর্ডার করেছেন আর কী এসেছে।",
        new: "নতুন পারচেজ অর্ডার",
        columns: {
            number: "নম্বর",
            supplier: "সরবরাহকারী",
            location: "ডেলিভারি",
            status: "অবস্থা",
            total: "মোট",
            date: "তৈরি",
        },
        statuses: {
            draft: "খসড়া",
            sent: "পাঠানো",
            partially_received: "আংশিক এসেছে",
            received: "সব এসেছে",
            closed: "বন্ধ",
            cancelled: "বাতিল",
        },
        empty: "এখনও কোনো পারচেজ অর্ডার নেই।",
        back: "সব পারচেজ অর্ডার",
        expected: "প্রত্যাশিত তারিখ",
        steps: { sent: "পাঠানো", closed: "বন্ধ", cancelled: "বাতিল" },
        actions: {
            send: "পাঠানো হয়েছে চিহ্নিত করুন",
            close: "অর্ডার বন্ধ করুন",
            cancel: "অর্ডার বাতিল করুন",
            pdf: "PDF ডাউনলোড",
            receive: "মাল গ্রহণ",
        },
        done: {
            created: "পারচেজ অর্ডার তৈরি হয়েছে।",
            send: "পাঠানো হয়েছে চিহ্নিত হলো।",
            close: "পারচেজ অর্ডার বন্ধ হয়েছে।",
            cancel: "পারচেজ অর্ডার বাতিল হয়েছে।",
        },
        cancelTitle: "এই পারচেজ অর্ডার বাতিল করবেন?",
        cancelBody: "এখনও কিছু আসেনি; অর্ডারটি বাতিল হিসেবে তালিকায় থাকবে।",
        closeTitle: "এই পারচেজ অর্ডার বন্ধ করবেন?",
        closeBody: "যা এখনও আসেনি তা আর আসবে বলে ধরা হবে না।",
        conflict: "অন্য কেউ এই পারচেজ অর্ডার বদলেছেন। সর্বশেষ সংস্করণ দেখানো হচ্ছে; আবার চেষ্টা করুন।",
        form: {
            title: "নতুন পারচেজ অর্ডার",
            description: "সরবরাহকারী আর মাল কোথায় যাবে বেছে নিন, তারপর পণ্য ও দাম।",
            expectedDate: "প্রত্যাশিত তারিখ (ঐচ্ছিক)",
            submit: "খসড়া তৈরি করুন",
        },
        lines: { title: "পণ্য", ordered: "অর্ডার", received: "এসেছে" },
    },
    receipts: {
        title: "গ্রহণ করা মাল",
        description: "স্টকে তোলা প্রতিটি ডেলিভারি, পারচেজ অর্ডারসহ বা ছাড়া।",
        new: "অর্ডার ছাড়া গ্রহণ",
        columns: {
            number: "নম্বর",
            supplier: "সরবরাহকারী",
            location: "লোকেশন",
            invoice: "ইনভয়েস",
            total: "মোট",
            date: "গ্রহণ",
        },
        empty: "এখনও কোনো মাল গ্রহণ করা হয়নি।",
        back: "সব গ্রহণ করা মাল",
        order: "পারচেজ অর্ডার",
        form: {
            title: "মাল গ্রহণ",
            titleForOrder: "{{number}}-এর মাল গ্রহণ",
            description: "পরিমাণগুলো আপনার দেওয়া দামে স্টকে যাবে; এতে গড় দাম হালনাগাদ হয়।",
            invoiceRef: "সরবরাহকারীর ইনভয়েস নং",
            receivedAt: "গ্রহণের তারিখ",
            left: "বাকি আছে: {{qty}}",
            submit: "স্টকে তুলুন",
        },
        done: "মাল স্টকে তোলা হয়েছে।",
        returned: "ফেরত",
        returnGoods: "মাল ফেরত",
    },
    returns: {
        title: "সরবরাহকারীকে ফেরত",
        description: "ফেরত পাঠানো মাল; প্রতিটি ফেরতে দেনা কমে।",
        new: "নতুন ফেরত",
        columns: {
            number: "নম্বর",
            supplier: "সরবরাহকারী",
            location: "লোকেশন",
            reason: "কারণ",
            total: "মোট",
            date: "তারিখ",
        },
        empty: "এখনও কোনো ফেরত নেই।",
        back: "সব ফেরত",
        receipt: "মাল গ্রহণ",
        form: {
            title: "মাল ফেরত",
            titleForReceipt: "{{number}} থেকে মাল ফেরত",
            description: "স্টক কমবে; সরবরাহকারী আপনাকে এর মূল্য দেনা।",
            reason: "কারণ",
            costHint: "খালি রাখলে: গ্রহণের দাম, অথবা বর্তমান গড় দাম।",
            left: "ফেরত দেওয়া যাবে: {{qty}}",
            submit: "মাল ফেরত দিন",
        },
        done: "ফেরত লেখা হয়েছে।",
        reasons: {
            damaged: "নষ্ট",
            wrong_item: "ভুল পণ্য",
            expired: "মেয়াদ শেষ",
            excess: "বেশি এসেছে",
            quality: "মানের সমস্যা",
            other: "অন্যান্য",
        },
    },
    aging: {
        title: "দেনা",
        description: "প্রতিটি সরবরাহকারীর কাছে দেনা, ডেলিভারি কত পুরনো সেই অনুযায়ী। পেমেন্ট আগে পুরনোটা শোধ করে।",
        columns: {
            supplier: "সরবরাহকারী",
            balance: "দেনা",
            current: "০–৩০ দিন",
            days31to60: "৩১–৬০ দিন",
            days61to90: "৬১–৯০ দিন",
            over90: "৯০ দিনের বেশি",
            advance: "অগ্রিম",
        },
        totals: "মোট",
        empty: "কোনো সরবরাহকারীর কাছে দেনা নেই।",
    },
};
//# sourceMappingURL=purchasing.js.map